<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { CHIP, CHIP_TONES } from '../ui';

// Origem de um dado da conta: Radar, site, cadastro ou corrigido pela equipe.
const props = defineProps({
  source: { type: String, default: null },
});

const { t } = useI18n();
const ICONS = {
  radar: 'i-ph-broadcast-duotone',
  site: 'i-ph-globe-duotone',
  account: 'i-ph-identification-card-duotone',
  team: 'i-ph-pencil-simple-duotone',
};
const label = computed(() =>
  t(`ONBOARDING_VISOR.SOURCES.${(props.source || 'none').toUpperCase()}`)
);
const tone = computed(() =>
  props.source ? CHIP_TONES.azul : CHIP_TONES.neutro
);
</script>

<template>
  <span :class="[CHIP, tone]" data-testid="fonte-chip">
    <Icon
      v-if="source"
      :icon="ICONS[source] || ICONS.site"
      class="size-3.5 flex-none"
    />
    {{ label }}
  </span>
</template>
